<template>
  <div class="w-32">
    <form-select
      v-if="stations.length > 1"
      v-model="value"
      :options="stationOptions"
      :allowEmpty="false"
      @update:modelValue="setStation"
      class="cursor-pointer uppercase"
      data-cy="selectStation"
      placeholder="Station"
    ></form-select>
  </div>
</template>

<script>
import api from '@/api'
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  props: {
    station: {
      type: String,
      default: 'ews'
    }
  },
  emits: ['update:station', 'update'],
  data() {
    return {
      value: this.station
    }
  },
  computed: {
    ...mapGetters(['access']),
    stations() {
      let access = this.access
      if (!access) return []

      // default to stations that currentUser has user and stagehand access to
      let stations = [...(access.user ?? []), ...(access.stagehand ?? [])]

      // temp fix to also give viewer access
      stations = [...stations, ...(access.viewer ?? [])]
      // if they dont have any stations, default to viewer access
      if (stations.length === 0) {
        stations = [...(access.viewer ?? [])]
      }

      // sort alphabetically
      stations.sort()

      // remove duplicates using lodash (_)
      stations = _.uniq(stations)
      return stations
    },
    stationOptions() {
      let _stations = []
      this.stations.forEach((x) => {
        _stations.push({ value: x.toLowerCase(), label: x.toUpperCase() })
      })

      return _stations
    }
  },
  mounted() {
    // make sure the value is one of the stations they have access to
    if (!this.stations.includes(this.value.toLowerCase())) {
      this.setStation(this.stations[0])
    }
  },
  methods: {
    setStation(station) {
      station = station || ''
      this.$emit('update:station', station.toLowerCase())
      this.$emit('update', station.toLowerCase())
    }
  }
}
</script>

<style></style>
